/**
 * LinkedListItem.ts
 * @author Diao Zheng
 * @file An Item inside a linked list.
 */
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _list, _remove, _add;
import { isSome } from "./Option";
export class LinkedListItem {
    constructor(value, list, remove, add) {
        _list.set(this, void 0);
        _remove.set(this, void 0);
        _add.set(this, void 0);
        this.popSelf = () => {
            if (isSome(this.previous)) {
                this.previous.next = this.next;
            }
            if (isSome(this.next)) {
                this.next.previous = this.previous;
            }
            __classPrivateFieldGet(this, _remove).call(this, this, __classPrivateFieldGet(this, _list));
            __classPrivateFieldSet(this, _list, undefined);
            return this;
        };
        this.addAfter = (value) => {
            const next = new LinkedListItem(value, __classPrivateFieldGet(this, _list), __classPrivateFieldGet(this, _remove), __classPrivateFieldGet(this, _add));
            next.previous = this;
            next.next = this.next;
            if (isSome(this.next)) {
                this.next.previous = next;
            }
            this.next = next;
            __classPrivateFieldGet(this, _add).call(this, next, this, __classPrivateFieldGet(this, _list));
        };
        this.addBefore = (value) => {
            if (isSome(this.previous)) {
                this.previous.addAfter(value);
                return;
            }
            const prev = new LinkedListItem(value, __classPrivateFieldGet(this, _list), __classPrivateFieldGet(this, _remove), __classPrivateFieldGet(this, _add));
            prev.next = this;
            this.previous = prev;
            __classPrivateFieldGet(this, _add).call(this, this, prev, __classPrivateFieldGet(this, _list));
        };
        this.value = value;
        __classPrivateFieldSet(this, _list, list);
        __classPrivateFieldSet(this, _remove, remove);
        __classPrivateFieldSet(this, _add, add);
    }
}
_list = new WeakMap(), _remove = new WeakMap(), _add = new WeakMap();
